import { gql } from '@apollo/client';

const UserInfoShared = gql`
  fragment UserInfoShared on User {
    id
    firstName
    lastName
    email
    emailDeliverabilityStatus
    phone
    imageUrl
    state
    withoutPlan
    legacyId
    partnerLocation {
      id
      name
    }
    account {
      id
      accountNumber
      users {
        id
        state
        lastLoginAt
      }
      patients {
        id
        firstName
        lastName
        legacyId
        arches
        dob
        birthDay
        birthMonth
        birthYear
      }
      accountAddresses {
        id
        address
        address2
        city
        region
        postalCode
        country
        isBilling
        isShipping
        isDefault
        accountId
      }
    }
    referrals {
      id
      hexCode
      state
      source
      patientAttributes {
        id
        includeEot
        sendToClinic
      }
      reminders
      consumedAt
      sent
      sentAt
      createdAt
    }
    lastLoginAt
    acceptSms
    acceptMarketing
    acceptSmsAt
    acceptMarketingAt
    createdAt
    updatedAt
  }
`;

export default UserInfoShared;
